import React, { useState, useEffect } from "react"
import "./styles.scss";

export default props => {

  let [ activeIndex, setActiveIndex ] = useState("");
  let [ load, setLoad ] = useState(false);
  let [ changeProps, setChangeProps ] = useState(false);


    // useEffect(() => {
    //     props.setFunction(activeIndex);
    // }, [activeIndex]);

    // useEffect(() => {
    //   if(!load) {
    //     setActiveIndex(props.active);
    //     setLoad(true);
    //   }
    // }, [load]);

    // useEffect(() => {
    //   if(load) {
    //     setChangeProps(true);
    //     setActiveIndex(props.active);
    //     setChangeProps(false);
    //   }
    // }, [props.active]);

  return (
    <div className={"radio-item" + ( props.class ? ' time' : '') }>
        <div className="wrapper">
            { props.data && props.data.map((item, index) => (
                <>
                  { (props.minimum && item.replace('%', '') >= props.minimum) && (props.maximum && item.replace('%', '') <= props.maximum) &&
                    <div key={ index } className={"radio " + (props.active === item ? 'active ' : '') + (props.gtmClass ? props.gtmClass : '')} onClick={ () => props.setFunction(item)}>{ item }</div>
                  }
                  { !props.minimum && !props.maximum &&
                    <div key={ index } className={"radio radio " + (props.active === item ? 'active ' : '') + (props.gtmClass ? props.gtmClass : '')} onClick={ () => props.setFunction(item)}>{ item }</div>
                  }
                </>
            ))}
        </div>
    </div>
  )
}
